// Gemelo de application/libraries/Apariencia_prefs.php: misma lista blanca,
// mismo formato de cookie. Sin DOM (se prueba con Vitest). La tercera copia de
// la lista vive en el script anti-parpadeo de noble/layout/head.php; la prueba
// de este módulo compara las tres.
export const DEFAULTS = Object.freeze({ tema: 'claro', paleta: 'libro', menu: 'horizontal', riel: 'abierto' });
export const VALIDOS = Object.freeze({
  tema: ['claro', 'oscuro', 'sistema'],
  paleta: ['libro', 'marca', 'grafito', 'bosque', 'atardecer'],
  menu: ['horizontal', 'lateral'],
  riel: ['abierto', 'colapsado'],
});
const CLAVES = { t: 'tema', p: 'paleta', m: 'menu', r: 'riel' };
const propia = function (obj, k) { return Object.prototype.hasOwnProperty.call(obj, k); };
const valido = function (k, v) { return typeof v === 'string' && VALIDOS[k].indexOf(v) >= 0; };

export function normalizar(entrada) {
  const salida = Object.assign({}, DEFAULTS);
  if (!entrada || typeof entrada !== 'object') return salida;
  Object.keys(VALIDOS).forEach(function (k) {
    if (valido(k, entrada[k])) salida[k] = entrada[k];
  });
  return salida;
}

// Aplica sobre las preferencias actuales solo los valores válidos del parcial:
// uno inválido se ignora (no regresa esa preferencia al default).
export function fusionar(actual, parcial) {
  const salida = normalizar(actual);
  if (!parcial || typeof parcial !== 'object') return salida;
  Object.keys(VALIDOS).forEach(function (k) {
    if (valido(k, parcial[k])) salida[k] = parcial[k];
  });
  return salida;
}

export function aCookie(prefs) {
  const p = normalizar(prefs);
  return Object.keys(CLAVES).map(function (c) { return c + '=' + p[CLAVES[c]]; }).join('&');
}

export function deCookie(valor) {
  const entrada = {};
  String(valor || '').split('&').forEach(function (par) {
    const i = par.indexOf('=');
    const c = i > 0 ? par.slice(0, i) : '';
    // Solo llaves propias del mapa: "constructor", "__proto__"... no cuentan.
    if (c && propia(CLAVES, c)) entrada[CLAVES[c]] = par.slice(i + 1);
  });
  return normalizar(entrada);
}

export function resolverTema(prefs, sistemaOscuro) {
  const p = normalizar(prefs);
  return p.tema === 'oscuro' || (p.tema === 'sistema' && !!sistemaOscuro) ? 'dark' : 'light';
}

export function atributos(prefs, sistemaOscuro) {
  const p = normalizar(prefs);
  return {
    'data-bs-theme': resolverTema(p, sistemaOscuro),
    'data-fd-tema': p.tema,
    'data-fd-palette': p.paleta,
    'data-fd-layout': p.menu,
    'data-fd-sidebar': p.riel,
  };
}
